import type { ReferralDraft } from '@/types/referrals';
import { addYears } from 'date-fns';
import type { ReactNode } from 'react';
import { z } from 'zod';
import type { useReferralState } from './useReferralState';
export const schema = z.object({
  service_type: z.enum(['Greiningarbeiðni', 'Meðferðarbeiðni', 'Þjónustubeiðni']),
  service_name: z.string().min(1),
  service_provider_id: z.string().min(1),
  priority: z.enum(['10', '20', '30', '40', '99']),
  valid_until: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
export type Fields = z.infer<typeof schema>;
export const defaults = (draft: ReferralDraft | null): Fields => ({
  service_type: draft?.service_type ?? 'Greiningarbeiðni',
  service_name: draft?.service_name ?? '',
  service_provider_id: draft?.service_provider_id ?? '',
  priority: String(draft?.priority ?? 99) as Fields['priority'],
  valid_until: (draft?.valid_until ?? addYears(new Date(), 1).toISOString()).slice(0, 10),
});
export const labels = {
  sending: 'Sending í gangi',
  unknown: 'Sending óstaðfest',
  needs_investigation: 'Sending þarfnast skoðunar',
  confirmed: 'Móttekin í Heklu',
  rejected: 'Tilvísun hafnað',
};
export const missingPatient = 'Settu inn kennitölu í „Sjúklingur“ til að senda tilvísun.';

export interface Props {
  taskId: number;
  sessionId?: string | null;
  letter: string;
  editor?: ReactNode;
  state: ReturnType<typeof useReferralState>;
  onSaved: (draft: ReferralDraft) => void;
  onReload: (letter: string) => void;
}
